'use client';
import { connect } from 'react-redux';

import getListData from '../selector/getListData.js';
import getNetworkingData from '../selector/getNetworkingData.js';
import login from '../action/login.js';
import {
  fetchChatrooms,
  fetchPinnedChatrooms,
  fetchUnreadChatrooms,
} from '../action/fetchChatrooms.js';
import setScrollerPositionData from '../action/setScrollerPositionData.js';
import fetchMeNotifications from '../action/fetchMeNotifications.js';
import addvalue from '../action/addvalue.js';
import getOperationData from '../selector/getOperationData.js';
import Chatrooms from '../page/Chatrooms.jsx';
import withRouter from '../component/WithRouter.jsx';
import { debounce } from 'lodash';
import getRouteHistory from '../selector/getRouteHistory.js';
import getNotificationListData, {
  SortField,
  SortOrder,
} from '../selector/getNotificationListData.js';
import getModalData from '../selector/getModalData.js';
import getConfigurations from '../selector/getConfigurations.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getMeData from '../selector/getMeData.js';
import { MERGE_OPERATION_DATA } from '../ActionTypes.js';
import { chatroomListType } from '../resource/chatroomConstants.js';
import { notificationList } from '../resource/notificationConstants.js';
import { addvalue as addvalueModalIds } from '../resource/modalId.js';
import { SEARCH_SWAGGER_ONLINE_FEED } from '../RemoteConfigKeys.js';
import { breakpoint } from '../style/variables.js';

function mapStateToProps(state) {
  const listType =
    getOperationData(state, ['chat'], 'listType') || chatroomListType.ALL;
  const listSelectPath = ['chatrooms', listType];
  const selectPath = ['chatrooms', listType];
  const nextPage = getListData(state, selectPath, 'nextPage');
  const apiCacheTimestamp = getOperationData(
    state,
    ['chat'],
    'apiCacheTimestamp'
  );
  const lastAutoChatId = getNotificationListData(
    state,
    notificationList.AUTO_CHAT,
    'lastItemId',
    SortField.TIMESTAMP,
    SortOrder.ASC
  );
  const notificationReadIds = getListData(
    state,
    ['notification', 'me', notificationList.READ],
    'itemIds'
  );
  const hasAutoChat = !!lastAutoChatId;
  const hasUnreadAutoChat =
    lastAutoChatId && !notificationReadIds?.includes(lastAutoChatId);
  const configurations = getConfigurations(state);
  const searchSwaggerOnlineFeed = getRemoteConfigData(
    state,
    SEARCH_SWAGGER_ONLINE_FEED
  );
  const deviceWidth = getOperationData(state, ['device'], 'width');
  const deviceHeight = getOperationData(state, ['device'], 'height');
  const hasChatrooms = !!getListData(
    state,
    ['chatrooms', chatroomListType.ALL],
    'itemIds'
  )?.length;
  return {
    itemIds: getListData(state, listSelectPath, 'itemIds'),
    isNextPageFetching: !!getNetworkingData(
      state,
      [...selectPath, nextPage],
      'isFetching'
    ),
    isFirstPageFetched: !!getNetworkingData(
      state,
      [...selectPath, 1],
      'isFetched'
    ),
    isFirstPageFetching: !!getNetworkingData(
      state,
      [...selectPath, 1],
      'isFetching'
    ),
    isAuthed: !!getMeData(state, 'id'),
    hasAutoChat,
    hasUnreadAutoChat,
    nextPage,
    scrollTop: getOperationData(state, ['scroller', 'chatrooms'], 'scrollTop'),
    previousRoute: getRouteHistory(state, 'previousRoute'),
    currentRoute: getRouteHistory(state, 'currentRoute'),
    isOnDesktop: deviceWidth > breakpoint.mobile,
    isDiamondShopOpen: !!['display', 'opening'].includes(
      getModalData(state, addvalueModalIds.DIAMOND_PACK_SELECTOR, 'status')
    ),
    hasChatrooms,
    deviceHeight,
    listType,
    apiCacheTimestamp,
    configurations,
    searchSwaggerOnlineFeed,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchChatrooms: data => dispatch(fetchChatrooms(data)),
    fetchUnreadChatrooms: data => dispatch(fetchUnreadChatrooms(data)),
    fetchPinnedChatrooms: data => dispatch(fetchPinnedChatrooms(data)),
    setScrollerPositionData: debounce(
      ({ scrollerPositionData, page }) =>
        dispatch(setScrollerPositionData({ scrollerPositionData, page })),
      50 // TODO: remote config
    ),
    setChatroomTab: ({ listType }) =>
      dispatch({
        type: MERGE_OPERATION_DATA,
        payload: {
          selectPath: ['chat'],
          data: {
            listType,
          },
        },
      }),
    fetchMeNotifications: data => dispatch(fetchMeNotifications(data)),
    addvalue: () => dispatch(addvalue()),
    login: () => dispatch(login()),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Chatrooms));
